// ============================================
// APP CONFIGURATION
// ============================================

const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1';
// Extract base URL for uploads (remove /api/v1 suffix)
const uploadsBaseUrl = apiUrl.replace(/\/api\/v\d+$/, '');

export const config = {
  apiUrl,
  uploadsBaseUrl,
  appName: 'Crew At Sea',
  appDescription: 'Denizci Paneli',
  supportEmail: 'support@crewatsea.com',
};

export const routes = {
  home: '/',
  login: '/login',
  register: '/register',
  profile: '/profile',
  certificates: '/profile/certificates',
  seaService: '/profile/sea-service',
  documents: '/profile/documents',
  jobs: '/jobs',
  applications: '/applications',
  favorites: '/favorites',
  companies: '/companies',
  notifications: '/notifications',
  settings: '/settings',
};
